<template>
  <div class="bg-secondary-9 p-2 extra-info-container">
    <div class="bg-white p-3">
      <section-title
        class="my-2"
        icon="fas fa-bell-exclamation"
        :title="title"
        title-class="extra-info-container__section-title__info"
      />
      <validation-observer ref="statusExtraInfo">
        <div class="row align-items-center">
          <div class="col-12 col-md-7 pl-md-5 mb-2">
            <div v-if="isApprovalAplication" class="row">
              <div class="col-12 col-md-7">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="approach.approachNumber"
                    custom-error-msg="El número de planteamiento es requerido."
                    :error="errors[0]"
                    label="Número de Planteamiento:"
                    type="text"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-5 mt-1 mt-md-0">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-date-picker
                    v-model="approach.approachDate"
                    custom-error-msg="La fecha de planteamiento a OGP es requerido."
                    :error="errors[0]"
                    label="Fecha de Planteamiento:"
                    placeholder="DD/MM/YYYY"
                  />
                </validation-provider>
              </div>
            </div>

            <div v-else class="row">
              <div class="col-12">
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-input
                    v-model="contractRegistration"
                    custom-error-msg="El registro de contrato es requerido."
                    :error="errors[0]"
                    label="Registro de Contrato:"
                    type="text"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="col-md-12 pl-md-5">
            <div class="d-flex justify-content-end align-items-center pl-md-5">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                variant="outline-danger mr-2"
                @click="cancel"
              >
                Cancelar
              </action-button>

              <action-button
                i="fa fa-save"
                variant="success px-3"
                @click="save"
              >
                Guardar
              </action-button>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import { proposalRequestStatus } from '@/utils/constants/proposalRequestStatus.js';

export default {
  name: 'ChangeProposalStatusRowInfo',
  components: {
    SectionTitle,
    ActionButton,
    CustomInput,
    CustomDatePicker,
  },
  props: {
    statusId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    approach: {},
    contractRegistration: null,
    isApprovalAplication: false,
    title: null,
  }),
  watch: {
    statusId: {
      immediate: true,
      handler(current) {
        switch (current) {
          case proposalRequestStatus.OGPApprovalApplication:
            this.title = 'Confirmación de Propuesta de OGP';
            this.isApprovalAplication = true;
            break;
          case proposalRequestStatus.RegisteredContractOC:
            this.title = 'Registro de Contrato Oficina del Contralor';
            this.isApprovalAplication = false;
            break;
          default:
            this.isApprovalAplication = false;
            break;
        }
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async save() {
      const isValid = await this.$refs.statusExtraInfo.validate();
      if (!isValid) return;

      const parameters = this.isApprovalAplication
        ? this.approach
        : { contractRegistration: this.contractRegistration };
      this.$emit('on-save-status', parameters, this.isApprovalAplication);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .extra-info-container {
  padding: 0.5rem;
  &__section-title {
    &__container {
      background: none;
      display: flex;
      align-items: center;

      .title-icon {
        font-size: 1rem;
        @media screen and (min-width: 768px) {
          font-size: 0.875rem;
        }
      }
    }

    &__info {
      font-size: 1rem;
      padding-left: 3px !important;
    }

    @media screen and (min-width: 768px) {
      padding-left: 0px !important;
    }
  }
}
</style>
